module.exports = __webpack_public_path__ + "static/AngelaHe11-b5ef10a629734ba1c794fe7eae35bec5.png";